<script setup lang="ts">
import { TriangleAlert } from 'lucide-vue-next'
const { t } = useI18n()

defineProps<{
  isOpen: boolean
  handleClose: (isOpen: boolean) => void
}>()

const emit = defineEmits<{
  (e: 'onDuplicate'): void
  (e: 'onSaveAndQuit'): void
}>()
</script>

<template>
  <BaseModal :is-open="isOpen" size="lg" :show-footer="false" @close="handleClose(false)">
    <div class="flex w-full flex-row justify-center">
      <div class="flex h-10 w-10 items-center justify-center rounded-full bg-yellow-100">
        <TriangleAlert class="h-6 w-6 text-yellow-600" />
      </div>
    </div>

    <p class="mt-5 text-center font-semibold">
      {{ t('pages.marketingFlow.marketingFlowEditPage.updateActiveConfirmation') }}
    </p>

    <p class="mb-5 mt-2 text-center text-sm text-foreground-secondary break-evenly">
      {{ t('pages.marketingFlow.marketingFlowEditPage.updateActiveDisclaimer') }}
    </p>

    <div class="flex w-full flex-row justify-center gap-3">
      <Button variant="outline" class="flex-1" @click="emit('onSaveAndQuit')">
        <span class="text-foreground">
          {{ t('pages.marketingFlow.marketingFlowEditPage.updateButtonConfirmation') }}
        </span>
      </Button>

      <Button variant="default-primary" class="flex-1" @click="emit('onDuplicate')">
        {{ t('pages.marketingFlow.marketingFlowEditPage.updateButtonDuplicate') }}
      </Button>
    </div>
  </BaseModal>
</template>
